import type { TypedValue } from '@medplum/core'

// Sidecar parameter carried on a fhirpath-patch `Parameters` PATCH entry. It
// is internal transport metadata (stripped before anything reaches the
// server): a history reference string (`Type/id/_history/{versionId}`)
// identifying the exact base version the patch was computed against. The base
// resource is loaded lazily from this ref at submit/preview time. The
// versionId is derived from the ref, so no separate version sidecar is stored.
export const SEEN_BASE_REF_PARAM = '__seenBaseRef' as const

export type FhirPathPatchOpType =
  | 'add'
  | 'insert'
  | 'delete'
  | 'replace'
  | 'move'

// Intermediate representation of one FHIRPath patch operation, mirroring the
// FHIR `Parameters`-based fhirpath-patch shape. `path` carries semantic
// intent (element-keyed, e.g. `Patient.identifier.where(system='X')`) rather
// than array indices.
export interface FhirPathPatchOperation {
  type: FhirPathPatchOpType
  path: string
  // Field name being added (add only).
  name?: string
  // Operation value (add/insert/replace).
  value?: TypedValue
  // Insertion index (insert only).
  index?: number
  // Move indices (move only).
  source?: number
  destination?: number
}
